import { memo } from 'react'

import CurrencyDescriptionItem from 'containers/Menu/AccountInfo/CurrencyDescriptionItem'
import SweepTooltip from 'containers/Menu/AccountInfo/TootlTip'
import { useAppSelector } from 'store/hooks'
import { getSweepstakeCurrencySelector } from 'store/modules/currencies/selectors'

const SweepsStakeAnimatedComponent = () => {
  const sweepBalance = useAppSelector(getSweepstakeCurrencySelector)

  return (
    <CurrencyDescriptionItem
      data-test='menu-currency-info-button'
      tooltip={<SweepTooltip balances={sweepBalance} />}
      currency='SC'
      showSign
      amount={sweepBalance?.amount}
    />
  )
}

export const SweepsStakeAnimated = memo(SweepsStakeAnimatedComponent)
